export const SmsStatus = Object.freeze({
  Sent: 'sent',
  Delivered: 'delivered',
  Error: 'error'
});

export const SmsStatusName = Object.freeze({
  [SmsStatus.Sent]: 'Отправлено',
  [SmsStatus.Delivered]: 'Доставлено',
  [SmsStatus.Error]: 'Ошибка'
});



// WEBPACK FOOTER //
// ./src/models/sms.js